import * as React from "react";
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Link } from "gatsby"
import Layout from "../../components/layout/layout";

import "./services.scss";



const ServicesPage = () => {
    

    return (
        <Layout>
            <>
                <section className="sec-common-page-heading" style={{ backgroundImage: "url('../images/laughing-doctors.jpg')" }}>
                    <Container>
                        <div className="d-flex justify-content-between align-items-center">
                            <h2>Services</h2>
                            <Breadcrumb>
                                <li className="breadcrumb-item">
                                    <Link to="/">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    Services
                                </li>                                
                            </Breadcrumb>
                        </div>
                    </Container>
                </section>

                
                <section className="sec-service-page">

                    <Container>
                        <div className="service-content">
                            <h3>Client services</h3>
                            <p>Our aim is to build, maintain and leave a lasting positive impact among all our clients. We pride ourselves in providing superior services delivered by our dedicated caring team. We have a wealth of experience and expertise to meet all of our clients staffing and care needs.</p>

                            <p className="mb-5">We ensure all staff training and qualifications are up to date and more importantly up to the required standard, allowing our staff to have the skills and the up to date knowledge to work competently.</p>
                        </div>
                    </Container>


                    <Container>
                        <Row>
                            <Col lg="6">
                                <div className="service-content">
                                        
                                    <h5 className="mb-3">Who we supply:</h5>
                                    <ul className="mb-5">
                                        <li><i className="bi bi-check-lg"></i>GRI</li>
                                        <li><i className="bi bi-check-lg"></i>NHS Hospitals and Private Hospitals</li>
                                        <li><i className="bi bi-check-lg"></i>Bupa Care Homes</li>
                                        <li><i className="bi bi-check-lg"></i>Four seasons Healthcare</li>
                                        <li><i className="bi bi-check-lg"></i>Restful Homes Group</li>
                                        <li><i className="bi bi-check-lg"></i>Alpha care homes</li>
                                        <li><i className="bi bi-check-lg"></i>Spring care homes</li>
                                        <li><i className="bi bi-check-lg"></i>Caram (AH) Limited</li>
                                        <li><i className="bi bi-check-lg"></i>Choices Housing</li>
                                    </ul>

                                    <h5 className="mb-3">All of our staff follow a robust recruitment procedure, see below:</h5>
                                    <ul className="mb-5">
                                        <li><i className="bi bi-check-lg"></i>Enhanced DBS checks</li>
                                        <li><i className="bi bi-check-lg"></i>They must speak, understand, read and write the English language fluently <br/>(evidenced by completing the interview questionnaire)   </li>
                                        <li><i className="bi bi-check-lg"></i>Competency and skills check</li>
                                        <li><i className="bi bi-check-lg"></i>Completing full application forms</li>
                                        <li><i className="bi bi-check-lg"></i>Two references verified</li>
                                        <li><i className="bi bi-check-lg"></i>Employment history for last 10 years</li>
                                        <li><i className="bi bi-check-lg"></i>Previous experience in the care sector</li>
                                        <li><i className="bi bi-check-lg"></i>Right to work in the UK</li>
                                        <li><i className="bi bi-check-lg"></i>Proof of ID/ photograph</li>
                                        <li><i className="bi bi-check-lg"></i>Proof of professional indemnity insurance (for Nurses)</li>
                                        <li><i className="bi bi-check-lg"></i>Confirmation of NMC PIN Number</li>
                                        <li><i className="bi bi-check-lg"></i>Face to face interview</li>
                                        <li><i className="bi bi-check-lg"></i>Immunisations</li>
                                        <li><i className="bi bi-check-lg"></i>ID badge uniform provided</li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg="6">
                                <div className="service-content">
                                    <h5 className="mb-3">Training provided to our staff</h5>
                                    <ul className="mb-5">
                                        <li><i className="bi bi-check-lg"></i>One full day induction</li>
                                        <li><i className="bi bi-check-lg"></i>New care certificate</li>
                                        <li><i className="bi bi-check-lg"></i>Health and safety</li>
                                        <li><i className="bi bi-check-lg"></i>Moving and transferring adults safely</li>
                                        <li><i className="bi bi-check-lg"></i>Safe handling of medication</li>
                                        <li><i className="bi bi-check-lg"></i>Infection control</li>
                                        <li><i className="bi bi-check-lg"></i>Safeguarding of vulnerable adults</li>
                                        <li><i className="bi bi-check-lg"></i>Person centred care</li>
                                        <li><i className="bi bi-check-lg"></i>Dementia awareness</li>
                                        <li><i className="bi bi-check-lg"></i>MAPA/DMI</li>
                                        <li><i className="bi bi-check-lg"></i>Mental capacity and deprivation of liberty safeguards</li>
                                        <li><i className="bi bi-check-lg"></i>Record keeping</li>
                                        <li><i className="bi bi-check-lg"></i>Care of the dying</li>
                                        <li><i className="bi bi-check-lg"></i>Eating disorder training</li>
                                    </ul>

                                    <h5 className="mb-3">Specialist courses for nurses</h5>
                                    <ul className="mb-5">
                                        <li><i className="bi bi-check-lg"></i>Diabetes and insulin management</li>
                                        <li><i className="bi bi-check-lg"></i>Syringe driver management</li>
                                        <li><i className="bi bi-check-lg"></i>Caring for patients with multiple sclerosis/ Tracheostomy Care</li>
                                        <li><i className="bi bi-check-lg"></i>Neurological observations</li>
                                        <li><i className="bi bi-check-lg"></i>Catheterisation (Male and Female)</li>
                                        <li><i className="bi bi-check-lg"></i>Principles of Nursing Practice</li>
                                        <li><i className="bi bi-check-lg"></i>Clinical Governance</li>
                                        <li><i className="bi bi-check-lg"></i>End of Life Care</li>
                                        <li><i className="bi bi-check-lg"></i>Supporting People’s Nutritional Needs</li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>

                        {/* <div className="service-content">
                            <h3>Client services</h3>
                            <p>Our aim is to build, maintain and leave a lasting positive impact among all our clients. We pride ourselves in providing superior services delivered by our dedicated caring team. We have a wealth of experience and expertise to meet all of our clients staffing and care needs.</p>

                            <p className="mb-5">We ensure all staff training and qualifications are up to date and more importantly up to the required standard, allowing our staff to have the skills and the up to date knowledge to work competently.</p>

                                
                            <h5 className="mb-3">Who we supply:</h5>
                            <ul className="mb-5">
                                <li><i className="bi bi-check-lg"></i>GRI</li>
                                <li><i className="bi bi-check-lg"></i>NHS Hospitals and Private Hospitals</li>
                                <li><i className="bi bi-check-lg"></i>Bupa Care Homes</li>
                                <li><i className="bi bi-check-lg"></i>Four seasons Healthcare</li>
                                <li><i className="bi bi-check-lg"></i>Restful Homes Group</li>
                                <li><i className="bi bi-check-lg"></i>Alpha care homes</li>
                                <li><i className="bi bi-check-lg"></i>Spring care homes</li>
                                <li><i className="bi bi-check-lg"></i>Caram (AH) Limited</li>
                                <li><i className="bi bi-check-lg"></i>Choices Housing</li>
                            </ul>

                            <h5 className="mb-3">All of our staff follow a robust recruitment procedure, see below:</h5>
                            <ul className="mb-5">
                                <li><i className="bi bi-check-lg"></i>Enhanced DBS checks</li>
                                <li><i className="bi bi-check-lg"></i>They must speak, understand, read and write the English language fluently <br/>(evidenced by completing the interview questionnaire)   </li>
                                <li><i className="bi bi-check-lg"></i>Competency and skills check</li>
                                <li><i className="bi bi-check-lg"></i>Completing full application forms</li>
                                <li><i className="bi bi-check-lg"></i>Two references verified</li>
                                <li><i className="bi bi-check-lg"></i>Employment history for last 10 years</li>
                                <li><i className="bi bi-check-lg"></i>Previous experience in the care sector</li>
                                <li><i className="bi bi-check-lg"></i>Right to work in the UK</li>
                                <li><i className="bi bi-check-lg"></i>Proof of ID/ photograph</li>
                                <li><i className="bi bi-check-lg"></i>Proof of professional indemnity insurance (for Nurses)</li>
                                <li><i className="bi bi-check-lg"></i>Confirmation of NMC PIN Number</li>
                                <li><i className="bi bi-check-lg"></i>Face to face interview</li>
                                <li><i className="bi bi-check-lg"></i>Immunisations</li>
                                <li><i className="bi bi-check-lg"></i>ID badge uniform provided</li>
                            </ul>
                        
                            <h5 className="mb-3">Training provided to our staff</h5>
                            <ul className="mb-5">
                                <li><i className="bi bi-check-lg"></i>One full day induction</li>
                                <li><i className="bi bi-check-lg"></i>New care certificate</li>
                                <li><i className="bi bi-check-lg"></i>Health and safety</li>
                                <li><i className="bi bi-check-lg"></i>Moving and transferring adults safely</li>
                                <li><i className="bi bi-check-lg"></i>Safe handling of medication</li>
                                <li><i className="bi bi-check-lg"></i>Infection control</li>
                                <li><i className="bi bi-check-lg"></i>Safeguarding of vulnerable adults</li>
                                <li><i className="bi bi-check-lg"></i>Person centred care</li>
                                <li><i className="bi bi-check-lg"></i>Dementia awareness</li>
                                <li><i className="bi bi-check-lg"></i>MAPA/DMI</li>
                                <li><i className="bi bi-check-lg"></i>Mental capacity and deprivation of liberty safeguards</li>
                                <li><i className="bi bi-check-lg"></i>Record keeping</li>
                                <li><i className="bi bi-check-lg"></i>Care of the dying</li>
                                <li><i className="bi bi-check-lg"></i>Eating disorder training</li>
                            </ul>

                            <h5 className="mb-3">Specialist courses for nurses</h5>
                            <ul className="mb-5">
                                <li><i className="bi bi-check-lg"></i>Diabetes and insulin management</li>
                                <li><i className="bi bi-check-lg"></i>Syringe driver management</li>
                                <li><i className="bi bi-check-lg"></i>Caring for patients with multiple sclerosis/ Tracheostomy Care</li>
                                <li><i className="bi bi-check-lg"></i>Neurological observations</li>
                                <li><i className="bi bi-check-lg"></i>Catheterisation (Male and Female)</li>
                                <li><i className="bi bi-check-lg"></i>Principles of Nursing Practice</li>
                                <li><i className="bi bi-check-lg"></i>Clinical Governance</li>
                                <li><i className="bi bi-check-lg"></i>End of Life Care</li>
                                <li><i className="bi bi-check-lg"></i>Supporting People’s Nutritional Needs</li>
                            </ul>

                        </div> */}
                        
                    </Container>

                </section>

                
            </>
        </Layout>
    )
}

export default ServicesPage
